const environment = {
  test: "http://localhost:3000",
  staging: "http://localhost:9000",
  live: "https://lasric.lagosstate.gov.ng",
};
const baseUrl = environment.live;

export { baseUrl };
